/**
 * AppShell — authenticated app layout.
 *
 * Replaces the BOLT-022 sidebar/drawer layout with a sticky top-bar nav
 * (TopNav) matching the 97 Display CRM reference design. Content fills the
 * remaining viewport height below the bar.
 *
 * ImpersonationBanner (BOLT-025) renders above the main content area — it
 * uses its own sticky AppBar so it stacks visually beneath the TopNav.
 */
import { type ReactNode } from 'react';
import { Box } from '@mui/material';
import { TopNav } from './TopNav.js';
import { ImpersonationBanner } from './ImpersonationBanner.js';
import { TrialStatusBanner } from './TrialStatusBanner.js';
import { QuickActionsFab } from './QuickActionsFab.js';

interface AppShellProps {
  children: ReactNode;
}

export function AppShell({ children }: AppShellProps) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <TopNav />
      <ImpersonationBanner />
      <TrialStatusBanner />
      <Box component="main" sx={{ flexGrow: 1, py: { xs: 3, sm: 4 } }}>
        <Box sx={{ maxWidth: 1280, mx: 'auto', px: 2 }}>{children}</Box>
      </Box>
      {/* Sticky quick-actions launcher — self-hides when the user can reach
          none of its destinations. */}
      <QuickActionsFab />
    </Box>
  );
}
